import { useRef, useState } from "react";
import { endpoints } from "../../hooks/endpoints";
import "../../styles/createQuiz.css";
import Animation from "../Animation";
import QuestionImg from "../quiz/QuestionImg";
import AddFromQuestionBank from "./AddFromQuestionBank";
import FileUploadProgressBar from "./FileUploadProgressBar";

import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { Trash2, Upload } from "lucide-react";
import { storage } from "../../firebaseConfig";
import { getFileUrl } from "../../hooks/utils";
import { useAppDispatch } from "../../store/hooks";
import { pushModal } from "../../store/slices/modalsSlice";
import {
  invokePortalRefetch,
  invokeUserRefetch,
} from "../../store/slices/storeSlice";
import GeneralMessageModal from "../Modals/GeneralMessageModal";
import Spinner from "../Spinner";
import { Button } from "../ui/button";

const CreateHomework = () => {
  const [questionsCount, setQuestionsCount] = useState([1]);
  const [questionsImages, setQuestionsImages] = useState({});
  const [successMsg, setSuccessMsg] = useState(null);
  const [publishing, setPublishing] = useState(false);
  const [fileProgress, setFileProgress] = useState(null);
  const hideCorrectAnswers = useRef();
  const randomizeQuestions = useRef();
  const mustAnswerAll = useRef();
  const [availableAnswers, setAvailableAnswers] = useState({});
  const dispatch = useAppDispatch();

  const getAnswersCount = (id) => {
    const answers = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
    const answersCount = availableAnswers[id];
    const answersOptions = [];
    for (let i = 0; i < answersCount && i < 10; i++) {
      answersOptions.push(answers[i]);
    }
    return answersOptions;
  };

  const maxMinCount = (e) => {
    if (e.target.value > 10) {
      setAvailableAnswers((prev) => ({
        ...prev,
        [e.target.id]: 10,
      }));
      document.getElementById(e.target.id).value = 10;
    } else if (e.target.value < 2) {
      setAvailableAnswers((prev) => ({
        ...prev,
        [e.target.id]: 2,
      }));
      document.getElementById(e.target.id).value = 2;
    } else {
      setAvailableAnswers((prev) => ({
        ...prev,
        [e.target.id]: e.target.value,
      }));
    }
  };

  const handleUploadFb = (e) => {
    if (!e.target.files[0]) {
      dispatch(
        pushModal(<GeneralMessageModal msg="يرجى اختيار ملف" btnMsg="حسنا" />)
      );
      return;
    }

    const imageRef = ref(storage, `questions-${new Date().getTime()}`);
    const uploadTask = uploadBytesResumable(imageRef, e.target.files[0]);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setFileProgress(progress.toFixed(2));
        console.log("Upload is " + progress + "% done");
      },
      (error) => {
        console.log(error);
        dispatch(
          pushModal(<GeneralMessageModal msg="يرجى اختيار ملف" btnMsg="حسنا" />)
        );
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          const tempObject = {};
          tempObject[`hw_question_img_url_${e.target.dataset.id}`] =
            getFileUrl(downloadURL);
          setQuestionsImages({ ...questionsImages, ...tempObject });
          setFileProgress(null);
        });
      }
    );
  };

  const handleUpload = async (e) => {
    if (!e.target.files[0]) {
      dispatch(
        pushModal(<GeneralMessageModal msg="يرجى اختيار ملف" btnMsg="حسنا" />)
      );
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", e.target.files[0], e.target.files[0].name);

      const xhr = new XMLHttpRequest();

      // Track the progress of the upload
      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percentComplete = (event.loaded / event.total) * 100;
          console.log(
            "uploadProgress",
            `Upload Progress: ${percentComplete.toFixed(2)}%`
          );
          if (percentComplete.toFixed(2) === "100.00") {
            setFileProgress(null);
          } else {
            setFileProgress(percentComplete.toFixed(2));
          }
          // You can update a progress bar or display the percentage as needed
        }
      });

      xhr.open("POST", endpoints.aws, true);
      // xhr.open("POST", endpoints.imageUpload, true);
      // xhr.open("POST", endpoints.eliteUpload, true);

      // Add the Authorization header with the token
      const token = JSON.parse(localStorage.getItem("user")).token;
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            try {
              const data = JSON.parse(xhr.responseText);

              if (data.success) {
                // File uploaded successfully
                const tempObject = {};
                tempObject[`hw_question_img_url_${e.target.dataset.id}`] =
                  data.url;
                setQuestionsImages({ ...questionsImages, ...tempObject });
                console.log(data);
                setFileProgress(null);
              } else {
                // File upload failed
                dispatch(
                  pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />)
                );
                setFileProgress(null);
              }
            } catch (error) {
              dispatch(
                pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />)
              );
              setFileProgress(null);
            }
          } else {
            // Server error
            dispatch(
              pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />)
            );
            setFileProgress(null);
          }
        }
      };

      xhr.send(formData);
    } catch (error) {
      // Network error
      dispatch(pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPublishing(true);
    try {
      const formData = new FormData(e.target);
      const formDataObject = {};
      for (const [key, value] of formData.entries()) {
        formDataObject[key] = value;
      }
      formDataObject["questionsCount"] = questionsCount;
      formDataObject["hideCorrectAnswers"] = hideCorrectAnswers.current.checked;
      formDataObject["randomizeQuestions"] = randomizeQuestions.current.checked;
      formDataObject["mustAnswerAll"] = mustAnswerAll.current.checked;

      const response = await fetch(endpoints.createHomework, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            JSON.parse(localStorage.getItem("user")).token
          }`,
        },
        body: JSON.stringify(formDataObject),
      });

      if (!response.ok) {
        // Handle server errors or other issues
        console.error("Error submitting the form");
        return;
      } else {
        setPublishing(false);
        setSuccessMsg(true);
        dispatch(invokePortalRefetch());
        dispatch(invokeUserRefetch());
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-ea shadow font-bold">
          إنشاء واجب جديد
        </h3>
        <form
          onSubmit={(e) => handleSubmit(e)}
          className="p-3 bg-white rounded-ea shadow-sm border space-y-4"
        >
          <div className="flex flex-col gap-2">
            <label htmlFor="hw-title" className="block font-medium">
              عنوان الواجب
            </label>
            <input
              type="text"
              id="hw-title"
              name="title"
              placeholder="عنوان الواجب"
              required
              className="w-full border rounded-lg p-2"
            />
          </div>

          {/* Example of other fields you commented: reuse same pattern */}

          {/* Checkboxes */}
          <div className="flex items-center gap-2">
            <input
              ref={hideCorrectAnswers}
              type="checkbox"
              id="hw-hide_correct_answers"
              className="size-4"
            />
            <label htmlFor="hw-hide_correct_answers">
              إخفاء الإجابات الصحيحة
            </label>
          </div>

          <div className="flex items-center gap-2">
            <input
              ref={randomizeQuestions}
              type="checkbox"
              id="hw-randomize_questions"
              className="size-4"
            />
            <label htmlFor="hw-randomize_questions">
              إعادة ترتيب الأسئلة لكل طالب
            </label>
          </div>

          <div className="flex items-center gap-2">
            <input
              ref={mustAnswerAll}
              type="checkbox"
              id="hw-must_answer_all"
              className="size-4"
            />
            <label htmlFor="hw-must_answer_all">يجب حل جميع الأسئلة</label>
          </div>

          {/* Dynamic questions */}
          {questionsCount.map((question, index) => (
            <div
              key={question}
              className="my-6 space-y-4 pt-4 border-t border-black"
            >
              <div className="flex gap-2">
                <h5 className="mb-3 pb-2 w-fit border-b-2 border-primary font-bold">
                  سؤال رقم {index + 1}
                </h5>
                {questionsCount.length > 1 && (
                  <Button
                    type="button"
                    variant="destructive"
                    onClick={() =>
                      setQuestionsCount((prev) =>
                        prev.filter((q) => q !== question)
                      )
                    }
                  >
                    <Trash2 className="size-4" />
                  </Button>
                )}
              </div>

              <AddFromQuestionBank
                questionNum={question}
                setQuestionsImages={setQuestionsImages}
                questionsImages={questionsImages}
                setAvailableAnswers={setAvailableAnswers}
                availableAnswers={availableAnswers}
                prefix="hw_"
              />

              <input
                type="hidden"
                id={`qid_${question}`}
                name={`qid_${question}`}
                className="question_counter"
              />

              {fileProgress &&
                fileProgress < 100 &&
                fileProgress >= 0 &&
                index + 1 === questionsCount.length && (
                  <FileUploadProgressBar fileProgress={fileProgress} />
                )}

              {!questionsImages[`hw_question_img_url_${question}`] && (
                <Button
                  type="button"
                  variant="outline"
                  className="hover:bg-purple-200 w-full h-fit py-5 rounded-lg bg-purple-100 border-2 border-dashed border-purple-500 flex flex-col gap-2 items-center justify-center"
                  onClick={() =>
                    document
                      .getElementById(`hw_question_img_input_${question}`)
                      ?.click()
                  }
                >
                  <Upload className="size-10" />
                  <p className="no-underline">إفع صورة السؤال</p>
                </Button>
              )}

              <input
                id={`hw_question_img_input_${question}`}
                onChange={handleUploadFb}
                data-id={question}
                type="file"
                hidden
                name={`hw_question_img_input_${question}`}
                className="w-full border rounded-ea p-2 mb-2"
              />

              {questionsImages[`hw_question_img_url_${question}`] && (
                <QuestionImg
                  id={`hw-uploaded-image-${question}`}
                  src={questionsImages[`hw_question_img_url_${question}`]}
                  alt=""
                  className="m-auto mb-2 rounded-lg"
                  border="2px solid #ddd"
                  onImgDelete={() => {
                    delete questionsImages[`hw_question_img_url_${question}`];
                    setQuestionsImages({ ...questionsImages });
                  }}
                />
              )}

              <input
                type="hidden"
                id={`hw_question_img_url_${question}`}
                value={questionsImages[`hw_question_img_url_${question}`]}
                name={`hw_question_img_url_${question}`}
                required
              />

              <div className="flex flex-col gap-2">
                <label
                  htmlFor={`hw_question_textarea_${question}`}
                  className="block font-medium"
                >
                  محتوى السؤال (اختياري)
                </label>
                <textarea
                  id={`hw_question_textarea_${question}`}
                  name={`hw_question_textarea_${question}`}
                  rows={3}
                  className="w-full border rounded-lg p-2"
                ></textarea>
              </div>

              <div className="flex flex-col gap-2">
                <label
                  htmlFor={`hw_question_ans_count_${question}`}
                  className="block font-medium"
                >
                  عدد الإجابات
                </label>
                <input
                  type="number"
                  id={`hw_question_ans_count_${question}`}
                  name={`hw_question_ans_count_${question}`}
                  max={10}
                  min={2}
                  required
                  onChange={maxMinCount}
                  className="w-full border rounded-lg p-2"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label
                  htmlFor={`hw_question_ans_${question}`}
                  className="block font-medium"
                >
                  الإجابة الصحيحة
                </label>
                <select
                  id={`hw_question_ans_${question}`}
                  name={`hw_question_ans_${question}`}
                  required
                  className="w-full border rounded-lg p-2"
                >
                  <option>الإجابة الصحيحة</option>
                  {getAnswersCount(`hw_question_ans_count_${question}`).map(
                    (ans) => (
                      <option key={ans} value={ans}>
                        {ans}
                      </option>
                    )
                  )}
                </select>
              </div>

              <div className="flex flex-col gap-2">
                <label
                  htmlFor={`hw_question_weight_${question}`}
                  className="block font-medium"
                >
                  الدرجة
                </label>
                <input
                  type="number"
                  min={0.5}
                  step={0.5}
                  id={`hw_question_weight_${question}`}
                  name={`hw_question_weight_${question}`}
                  required
                  className="w-full border rounded-lg p-2"
                />
              </div>
            </div>
          ))}

          <Button
            type="button"
            disabled={fileProgress && fileProgress < 100 && fileProgress >= 0}
            onClick={() =>
              setQuestionsCount((prev) => [...prev, prev[prev.length - 1] + 1])
            }
            className="rounded-lg font-bold px-4 py-2 bg-green-600 hover:bg-green-700 text-white"
          >
            +
          </Button>

          <Button
            type="submit"
            className="w-full rounded-lg"
            disabled={
              (typeof fileProgress === "number" && fileProgress < 100) ||
              publishing
            }
          >
            {publishing ? <Spinner variant="button" /> : "نشر"}
          </Button>

          {successMsg && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mt-4">
              تم إنشاء الواجب يمكنك الآن ربطه بالحصة
            </div>
          )}
        </form>
      </div>
    </Animation>
  );
};

export default CreateHomework;
